import src from "IMAGE";
export default { src, width: 1600, height: 960, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAO0lEQVR42oWOKw4AMAhDuf9NEQh+aqILU5CQTNS0r01JVU9mYlNl1A13f+reAEQEzIyI2IFqm9lc+H24qamaF1jv2E4AAAAASUVORK5CYII="};
